import CompanyRoutes from "../../../apiRoutes/CompanyRoutes";
import { api } from "../../ConsumeApiController";

// 1. Obtener la lista de chats activos
export async function getAiConversations() {
    const response = await api.get(CompanyRoutes.AI.CONVERSATIONS.GET_CONVERSATIONS);
    return response;
}

// 2. Obtener los mensajes de una conversación específica
export async function getAiMessages(conversationId) {
    // Aquí concatenamos el ID a la ruta base
    const response = await api.get(CompanyRoutes.AI.CONVERSATIONS.GET_MESSAGES(conversationId));
    return response;
}

// 3. Cambiar el estado (Pausar IA / Reanudar IA) para un chat
export async function toggleConversationStatus(conversationId, status) {
    const response = await api.put(CompanyRoutes.AI.CONVERSATIONS.CHANGE_STATUS(conversationId), { 
        status: status 
    });
    return response;
}

// 4. Enviar un mensaje manual como humano
export async function sendManualMessage(conversationId, message) {
    const response = await api.post(CompanyRoutes.AI.CONVERSATIONS.SEND_MESSAGE(conversationId), { 
        message: message 
    });
    return response;
}